(() => {
  (function (Drupal, once) {
    'use strict';

    const DEFAULT_FIELD_NAME = 'field_project_topic_target_id';

    function normalize(text) {
      return (text || '').trim().toLowerCase();
    }

    // Matches the "All" sentinel by visible label text.
    function isAllLabel(labelNorm) {
      return (
        labelNorm === '__all__' ||
        labelNorm === 'all' ||
        labelNorm === 'alle' ||
        labelNorm === '- alle -'
      );
    }

    // Matches the "All" sentinel by option value (term id). Empty value = All.
    function isAllValue(value) {
      const v = normalize(value);
      return v === '' || v === '__all__' || v === 'all' || v === 'alle';
    }

    function getTopicSelect(form, fieldName) {
      if (!form) return null;
      return (
        form.querySelector(`select[name="${fieldName}"]`) ||
        form.querySelector(`select[name="${fieldName}[]"]`)
      );
    }

    function getTopicInputs(form, fieldName) {
      if (!form) return [];
      return Array.from(
        form.querySelectorAll(`input[name="${fieldName}"], input[name="${fieldName}[]"]`)
      );
    }

    function getInputLabel(input) {
      const id = input.getAttribute('id');
      if (id && input.form) {
        const label = input.form.querySelector(`label[for="${id}"]`);
        if (label) return label.textContent;
      }
      const parentLabel = input.closest('label');
      return parentLabel ? parentLabel.textContent : '';
    }

    // Current selected option value (term id), NOT the (translatable) label.
    function getCurrentValue(form, fieldName) {
      const select = getTopicSelect(form, fieldName);
      if (select) {
        const opt = select.options[select.selectedIndex];
        return opt ? String(opt.value) : '';
      }
      const inputs = getTopicInputs(form, fieldName).filter((i) => i.checked);
      if (inputs.length) {
        return String(inputs[0].value);
      }
      return '';
    }

    function cssEscape(value) {
      return window.CSS && CSS.escape ? CSS.escape(value) : value;
    }

    // Apply a topic selection by stable option value (id); fall back to label.
    // The id path is language-independent and is what makes this work behind the
    // Weglot proxy, where option text is translated but values are not.
    function applyTopicValue(form, fieldName, topicId, topicLabel) {
      const id = (topicId == null ? '' : String(topicId)).trim();
      const labelNorm = normalize(topicLabel != null ? topicLabel : topicId);
      const all = isAllValue(id) || isAllLabel(labelNorm);
      const select = getTopicSelect(form, fieldName);

      if (select) {
        if (all) {
          let matchedAll = false;
          Array.from(select.options).forEach((opt) => {
            if (matchedAll) return;
            const optValue = normalize(opt.value);
            if (opt.value === '' || optValue === 'all' || isAllLabel(normalize(opt.textContent))) {
              select.value = opt.value;
              matchedAll = true;
            }
          });
          if (!matchedAll) select.value = '';
          return matchedAll;
        }
        let found = false;
        if (id) {
          Array.from(select.options).forEach((opt) => {
            if (!found && String(opt.value) === id) {
              select.value = opt.value;
              found = true;
            }
          });
        }
        if (!found && labelNorm) {
          Array.from(select.options).forEach((opt) => {
            if (!found && normalize(opt.textContent) === labelNorm) {
              select.value = opt.value;
              found = true;
            }
          });
        }
        if (!found) select.value = '';
        return found;
      }

      const inputs = getTopicInputs(form, fieldName);
      if (inputs.length) {
        if (all) {
          let matchedAll = false;
          inputs.forEach((input) => {
            const isAll = input.value === 'All' || isAllLabel(normalize(getInputLabel(input)));
            input.checked = isAll;
            if (isAll) matchedAll = true;
          });
          return matchedAll;
        }
        let matched = false;
        inputs.forEach((input) => {
          let isMatch = false;
          if (id) {
            isMatch = String(input.value) === id;
          } else if (labelNorm) {
            isMatch = normalize(getInputLabel(input)) === labelNorm;
          }
          if (isMatch) matched = true;
          input.checked = isMatch;
        });
        if (!matched) inputs.forEach((i) => (i.checked = false));
        return matched;
      }

      return false;
    }

    Drupal.behaviors.projectsTopicFilter = {
      attach: function (context) {
        once('projectsTopicFilter', '[data-filter-topic]', context).forEach(function (container) {
          let badges = container.querySelectorAll('.badge');
          const form = container.closest('form') || (container.closest('.projects-view') || document).querySelector('form');
          const fieldName = container.getAttribute('data-topic-field') || DEFAULT_FIELD_NAME;

          // Alphabetically sort badges (All first)
          (function sortBadges() {
            const allBadge =
              container.querySelector('[data-topic-id="__all__"]') ||
              container.querySelector('[data-topic-value="__all__"]') ||
              container.querySelector('[data-category-value="__all__"]');
            const others = Array.from(container.querySelectorAll('.badge'))
              .filter(b => b !== allBadge)
              .sort((a,b)=>a.textContent.localeCompare(b.textContent, undefined, {sensitivity:'base'}));
            if (allBadge) container.appendChild(allBadge);
            others.forEach(b=>container.appendChild(b));
            badges = container.querySelectorAll('.badge');
          })();

          function submitForm() {
            if (!form) return;
            const submitBtn = form.querySelector('.form-submit, input[type="submit"], button[type="submit"]');
            if (submitBtn) {
              submitBtn.click();
              return;
            }
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          }

          function setPressed(badge, isActive) {
            badge.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }

          badges.forEach(function (badge) {
            badge.addEventListener('click', function () {
              if (badge.classList.contains('is-active')) return;
              badges.forEach(function (b) {
                b.classList.remove('is-active');
                setPressed(b, false);
              });
              badge.classList.add('is-active');
              setPressed(badge, true);
              applyTopicValue(form, fieldName, badge.getAttribute('data-topic-id'), badge.getAttribute('data-topic-value'));
              submitForm();
            });
          });

          // Determine the initially active badge from the current option VALUE
          // (term id), which is stable across languages.
          const currentVal = getCurrentValue(form, fieldName);
          let initBadge = null;
          if (!currentVal || isAllValue(currentVal)) {
            initBadge =
              container.querySelector('[data-topic-id="__all__"]') ||
              container.querySelector('[data-topic-value="__all__"]');
          } else {
            initBadge = container.querySelector('[data-topic-id="' + cssEscape(currentVal) + '"]');
            if (!initBadge) {
              initBadge =
                container.querySelector('[data-topic-id="__all__"]') ||
                container.querySelector('[data-topic-value="__all__"]');
            }
          }
          badges.forEach(b => b.classList.remove('is-active'));
          if (initBadge) {
            initBadge.classList.add('is-active');
          }
          badges.forEach(function (b) {
            setPressed(b, b.classList.contains('is-active'));
          });
        });
      }
    };
  })(Drupal, once);
})();
